var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 p-0"},[_c('p',{staticClass:"m-0 worksansr"},[_vm._v(" "+_vm._s(_vm.question.alternatives[0].text ? _vm.question.alternatives[0].text : "Não foi respondido!")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }